import type { GetControlTestOversightResultByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetControlTestOversightResultByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetControlTestOversightResultByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetControlTestOversightResultByIdArgs = { id: string };

export const useGetControlTestOversightResultById = createQueryHook<
  UseGetControlTestOversightResultByIdArgs,
  GetControlTestOversightResultByIdResponseRow[],
  GetControlTestOversightResultByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.testResult.controlTestOversightResultById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({ control_test_oversight_result: data }),
  graphqlDocument: GetControlTestOversightResultByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
